// extracted by mini-css-extract-plugin
export default {"inaccessible":"src-hello-react-components-debug-test-ids-module__inaccessible--JVEtg"};